import { useFormContext } from "react-hook-form";

import { cx } from "class-variance-authority";
import { get } from "lodash";
import { DropzoneState } from "react-dropzone";
import { useTranslation } from "react-i18next";

interface Props extends Partial<DropzoneState> {
    name: string;
    isLoading?: boolean;
    className?: string;
}

export const DropPlaceholder = ({ name, isDragActive, isDragReject, isLoading, className }: Props) => {
    const { t } = useTranslation("form");
    // Outside a <Form> react-hook-form hands back null rather than throwing, so the placeholder
    // also works on its own — the receipt list drops files without a form around them.
    const form = useFormContext();
    const error = form ? get(form.formState.errors, name) : undefined;
    const isInvalid = Boolean(error);

    return (
        <div
            className={cx(
                isDragActive && "!tw-border-success",
                "tw-card-bordered tw-border-2 !tw-border-dashed tw-border-accents-4 tw-text-center tw-text-accents-5",
                className
            )}
        >
            {isLoading ? (
                <span className="tw-animate-pulse">{t("dropzone.loading")}</span>
            ) : isInvalid ? (
                <span className="tw-font-semibold tw-text-error">{error?.message || t("dropzone.invalid")}</span>
            ) : isDragReject ? (
                <span>{t("dropzone.rejected")}</span>
            ) : (
                <span>{t("dropzone.prompt")}</span>
            )}
        </div>
    );
};
